const queueRoutes = [
  // Disabled -------------------------
  {
    path: '/aguardar-notificacao-fila',
    name: 'queue-line',
    component: () => import('@/views/conclusion/queue/QueueLine.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Aguarde ser chamado...',
      },
    },
  },
  {
    path: '/chamada-fila',
    name: 'queue-notification',
    component: () => import('@/views/conclusion/queue/QueueNotification.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'É a sua vez!',
      },
    },
  },
  // -----------------------------------
];

export default queueRoutes;
